// extracted by mini-css-extract-plugin
export default {"bannerFullBox":"BoardBanner_bannerFullBox__VGNC0","detail":"BoardBanner_detail__5upW3","smInner":"BoardBanner_smInner__g9c9w"};